import i18next from 'i18next';

import '@pages/app';

import { captureException } from '@sentry/browser';
import {
  isButtonElement,
  isHTMLElement,
  isInputElement,
} from '@/utils/elementTypeGuards';
import { fetchSignInMethodsForEmail, getAuth } from 'firebase/auth';
import validateEmail from '@/utils/validateEmail';
import { sendResetPasswordEmail } from '@/api/userApi';

const NOT_SIGNED_IN = 'auth/not-signed-in';
const NOT_EMAIL_FORMAT = 'not-email-format';

const titleEl = document.querySelector('.title');
const subTitleEl = document.querySelector('.subtitle');
const inputEl = document.querySelector('.form-control');
const buttonEl = document.querySelector('.submit-button');
const email_error = document.querySelector('#email_error');

try {
  if (
    !isHTMLElement(titleEl) ||
    !isHTMLElement(subTitleEl) ||
    !isInputElement(inputEl) ||
    !isButtonElement(buttonEl) ||
    !isHTMLElement(email_error)
  ) {
    throw new Error('Element is not found');
  }

  titleEl.innerHTML = i18next.t('resetPassword.title');
  subTitleEl.innerHTML = i18next.t('resetPassword.subtitle');
  inputEl.placeholder = i18next.t('resetPassword.placeholder');
  buttonEl.innerHTML = i18next.t('resetPassword.button');

  email_error.innerHTML = '.';

  const auth = getAuth();

  const buttonBlurHandler = async () => {
    const email = inputEl.value;
    let error = false;

    try {
      const isEmailFormat = validateEmail(email);
      if (!isEmailFormat) throw new Error(NOT_EMAIL_FORMAT);

      const userProviders = await fetchSignInMethodsForEmail(auth, email);
      if (!userProviders.includes('password')) throw new Error(NOT_SIGNED_IN);

      email_error.style.visibility = 'hidden';
      buttonEl.disabled = false;
    } catch (e) {
      if (e instanceof Error === false) return error;

      error = true;

      email_error.style.visibility = 'visible';
      buttonEl.disabled = true;

      if (NOT_EMAIL_FORMAT === e.message) {
        email_error.innerHTML = i18next.t('resetPassword.error.notEmailFormat');
        return error;
      } else if (NOT_SIGNED_IN === e.message) {
        email_error.innerHTML = i18next.t(
          'resetPassword.error.notSignedInByPassword',
        );
        return error;
      }

      captureException(e);
    }

    return error;
  };

  const buttonClickHandler = async (e: MouseEvent) => {
    e.preventDefault();
    const email = inputEl.value;

    const error = await buttonBlurHandler();
    if (error) return;
    try {
      await sendResetPasswordEmail(email);

      titleEl.innerHTML = i18next.t('resetPassword.success.title');
      subTitleEl.innerHTML = i18next.t('resetPassword.success.subtitle');

      email_error.style.visibility = 'hidden';
      buttonEl.style.display = 'none';
      inputEl.style.display = 'none';
    } catch (e) {
      if (e instanceof Error === false) return;

      email_error.style.visibility = 'visible';

      if (NOT_EMAIL_FORMAT === e.message) {
        email_error.innerHTML = i18next.t('resetPassword.error.notEmailFormat');
        return;
      } else if (NOT_SIGNED_IN === e.message) {
        email_error.innerHTML = i18next.t(
          'resetPassword.error.notSignedInByPassword',
        );
        return;
      }

      captureException(e);
    }
  };

  inputEl.addEventListener('blur', buttonBlurHandler);
  buttonEl.addEventListener('click', buttonClickHandler);
} catch (e) {
  captureException(e);
}
